import React from "react";
import { Row, Col } from "react-bootstrap";
import TooltipHelper from "./TooltipHelper";

interface ToolTip {
  title: string;
  subTitle?: string;
  toggleFilter?: React.ReactNode;
  toolTipText?: string;
  tooltipIcon?: string;
  /*
   * Parameter will appear in the upper right hand side
   */
  additionalInfo?: React.ReactNode;
}

interface CardHeaderProps extends ToolTip {
  tooltips?: ToolTip[];
}

const CardHeader = (props: CardHeaderProps) => {
  const {
    title,
    subTitle,
    toggleFilter,
    toolTipText,
    tooltipIcon,
    tooltips,
    additionalInfo,
  } = props;

  function MultipleTips() {
    if (!toolTipText) return null;
    if (tooltips) {
      return tooltips.map((tooltip) => {
        if (tooltip) {
          return (
            <TooltipHelper
              toolTipClass="float-right mr-0 pt-0"
              text={tooltip.toolTipText || ""}
              altIcon={tooltip.tooltipIcon}
            />
          );
        } else return null;
      });
    } else
      return (
        <TooltipHelper
          toolTipClass=" float-right tooltip-title mr-0 pt-0"
          text={toolTipText}
          altIcon={tooltipIcon}
        />
      );
  }
  return (
    <React.Fragment>
      <Row className="d-flex w-100 justify-content-between">
        <Col xs={10} lg={8} className="d-flex flex-column">
          <h3 className="card-title">{title}</h3>
          {subTitle ? <span className="font-italic">{subTitle}</span> : null}
        </Col>
        <Col className="d-flex justify-content-end">
          <p>{MultipleTips()}</p>
          <div>{toggleFilter}</div>
        </Col>
        {additionalInfo ? (
          <Col xs={12} lg={3}>
            {additionalInfo}
          </Col>
        ) : null}
      </Row>
      <hr className="card-divider"></hr>
    </React.Fragment>
  );
};

export default CardHeader;
